import React, { Component } from "react";
// export const WIDTH_HEIGHT_DEFAULT_RATIO = 5.8
import SignatureCanvas from "react-signature-canvas";
import styled from "styled-components";

const SignatureCanvasContainerReadOnly = styled.div`
  pointer-events: none;
`;

class SignatureCanvasResponsiveReadOnly extends Component {
  constructor(props) {
    super(props);

    this.signatureCanvasRef = React.createRef();
    this.state = {};
  }

  componentDidMount() {
    this._drawReadOnlySignature();
  }

  componentDidUpdate() {
    this._drawReadOnlySignature();
  }

  _scaleSignatureData(data, ratio) {
    if (!data || !_.isArray(data)) {
      return null;
    }

    return _.map(data, (stroke) =>
      _.map(stroke, (point) => ({
        ...point,
        x: point.x * ratio,
        y: point.y * ratio,
      }))
    );
  }

  _drawReadOnlySignature() {
    if (this.signatureCanvasRef.current) {
      const signatureData = this.props.dataFunc();

      if (signatureData.data && _.isArray(signatureData.data)) {
        this.signatureCanvasRef.current.fromData(
          this._scaleSignatureData(
            signatureData.data,
            this.state.canvasWidth / signatureData.width
          )
        );
      }
    }
  }

  render() {
    const { widthHeightRatio } = this.props;

    return (
      <div
        ref={(ref) =>
          ref &&
          !this.state.canvasWidth &&
          this.setState({ canvasWidth: ref.offsetWidth })
        }
      >
        <SignatureCanvasContainerReadOnly>
          {this.state.canvasWidth && (
            <SignatureCanvas
              ref={this.signatureCanvasRef}
              canvasProps={{
                width: this.state.canvasWidth,
                height: this.state.canvasWidth / widthHeightRatio,
              }}
            />
          )}
        </SignatureCanvasContainerReadOnly>
      </div>
    );
  }
}

export default SignatureCanvasResponsiveReadOnly;
